import { Description, Heading3 } from '@casavo/base-ui'
import cn from 'classnames'
import { useFormikContext } from 'formik'
import useTranslation from 'next-translate/useTranslation'
import { useEffect } from 'react'
import * as Yup from 'yup'

import { FormikPriceInputSlider } from '@/components/FormFields/FormikPriceInputSlider'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { paddingBottom, paddingTop } from '@/shared-styles/styles.css'

import { suggestedPropertyFlowStepPaddingTop, suggestedPropertyFlowStepContent, maxWidth400 } from './styles.css'

export const MaxBudgetIntialValue = () => ({ maxBudget: null })

export const MaxBudgetValidation = () =>
  Yup.object().shape({
    maxBudget: Yup.number().required().min(10000),
  })

export const MaxBudget: React.FC = () => {
  const { t } = useTranslation()
  const { validateForm } = useFormikContext()

  useEffect(() => {
    validateForm()
  }, [])

  return (
    <main className={suggestedPropertyFlowStepPaddingTop}>
      <div className={cn(suggestedPropertyFlowStepContent, paddingTop['3xl'])}>
        <Heading3 className={paddingBottom.m}>{t('buyer-interest-flow:MaxBudget_Question')}</Heading3>
        <Description className={sprinkles({ paddingBottom: { desktop: 'xl', mobile: '2xl' } })}>
          {t('buyer-interest-flow:MaxBudget_Description')}
        </Description>
        <FormikPriceInputSlider className={maxWidth400} max={1000000} min={10000} name="maxBudget" scale={5000} />
      </div>
    </main>
  )
}
